module.exports = __webpack_public_path__ + "img/index01.7a4c1bb4.svg";